<template lang="html">
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card" style="width: 600px; height: 90%;">
            <div class="modal-card-head has-background-danger is-size-4">
                <div class="modal-card-title">{{title}}</div>
                <button class="delete" aria-label="close"
                        @click="$emit('close-modal')"></button>
            </div>
            <div class="modal-card-body">
                <span class="has-text-weight-bold">{{message}}</span>
                <hr>
                <pre>{{stacktrace}}</pre>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "ModalLaboError",
  props: {
    title: String,
    stacktrace: String,
    message: String
  },
  methods: {
    close() {
      this.$emit('close-modal');
    }
  }
};
</script>
